import type { EffectiveQuotationItems } from "./types";

export interface QuotationStoreOption {
  id: string;
  name: string;
}

export type QuotationStoreControl =
  | { mode: "empty"; selectedStoreId: ""; selectedStoreName: "" }
  | { mode: "label"; selectedStoreId: string; selectedStoreName: string }
  | { mode: "select"; selectedStoreId: string; selectedStoreName: string };

export function getInitialQuotationStoreId(
  stores: QuotationStoreOption[],
  savedStoreId: string | null | undefined,
): string {
  if (savedStoreId && stores.some((store) => store.id === savedStoreId)) {
    return savedStoreId;
  }
  return stores[0]?.id ?? "";
}

export function getQuotationStoreControl(
  stores: QuotationStoreOption[],
  selectedStoreId: string,
): QuotationStoreControl {
  const selected =
    stores.find((store) => store.id === selectedStoreId) ?? stores[0];
  if (!selected) {
    return { mode: "empty", selectedStoreId: "", selectedStoreName: "" };
  }
  return {
    mode: stores.length > 1 ? "select" : "label",
    selectedStoreId: selected.id,
    selectedStoreName: selected.name,
  };
}

export function getActiveQuotationStoreId({
  isStoreUser,
  stores,
  selectedStoreId,
}: {
  isStoreUser: boolean;
  stores: QuotationStoreOption[];
  selectedStoreId: string;
}): string {
  const storeControl = getQuotationStoreControl(stores, selectedStoreId);
  if (isStoreUser || stores.length === 1) {
    return storeControl.selectedStoreId;
  }
  return stores.some((store) => store.id === selectedStoreId)
    ? selectedStoreId
    : "";
}

export function shouldLoadEffectiveItems({
  isStoreUser,
  date,
  selectedStoreId,
}: {
  isStoreUser: boolean;
  date?: string;
  selectedStoreId?: string;
}): boolean {
  if (!date) return false;
  if (isStoreUser) return Boolean(selectedStoreId);
  return true;
}

export function getReadyEffectiveItems(
  data: EffectiveQuotationItems | undefined,
  isPlaceholderData: boolean,
) {
  return isPlaceholderData ? undefined : data;
}
